import React from "react";
import Marquee from "react-fast-marquee";

const ScrollAdd = () => {
  return (
    <Marquee
      style={{
        backgroundColor: "#000",
        color: "#ff9a2f",
        padding: "6px",
        fontFamily: '"Inter", sans-serif',
        boxShadow:
          "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
      }}
      gradient={false}
      speed={40}>
      <p>
        <span className="scroll-text-gradent" style={{ marginRight: "50px" }}>
          WHERE IMAGINATION TAKES FLIGHT
        </span>{" "}
        <span className="scroll-text-gradent" style={{ marginRight: "50px" }}>
          ACADEMY OF TECHNOLOGY & ADVENTURE FOR SCHOOL STUDENTS
        </span>{" "}
        <span className="scroll-text-gradent" style={{ marginRight: "50px" }}>
          WHERE IMAGINATION TAKES FLIGHT
        </span>{" "}
        <span className="scroll-text-gradent" style={{ marginRight: "50px" }}>
        ACADEMY OF TECHNOLOGY & ADVENTURE FOR SCHOOL STUDENTS
        </span>{" "}
        <span style={{ marginRight: "50px" }}>
          WHERE IMAGINATION TAKES FLIGHT
        </span>{" "}
        <span className="scroll-text-gradent" style={{ marginRight: "50px" }}>
        ACADEMY OF TECHNOLOGY & ADVENTURE FOR SCHOOL STUDENTS
        </span>
        <span className="scroll-text-gradent" style={{ marginRight: "50px" }}>
          WHERE IMAGINATION TAKES FLIGHT
        </span>
        <span className="scroll-text-gradent" style={{ marginRight: "50px" }}>
        ACADEMY OF TECHNOLOGY & ADVENTURE FOR SCHOOL STUDENTS
        </span>
      </p>
    </Marquee>
  );
};

export default ScrollAdd;
